import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Card, Box, Typography, IconButton, Tooltip, Chip
} from '@mui/material';
import Icon from '@mdi/react';
import {
    mdiTruckPlusOutline,
    mdiInformationOutline,
    mdiDeleteOutline, mdiMapOutline,
} from '@mdi/js';
import { selectSelectedRoute } from '../../../features/tripcenter/routeSlice';
import {
    getOneRoute, setSelectedRoute, setDetailViewOpen, setMapViewActive,
    deactivateRoute
} from '../../../features/tripcenter/routeSlice';

import TripCreateForm from '../tripComponents/TripCreateForm';
import NewTrip from '../tripComponents/NewTrip';


const RouteListItem = ({ route }) => {
    const dispatch = useDispatch();
    const selectedRoute = useSelector(selectSelectedRoute);
    //const isDetailViewOpen = useSelector(selectIsDetailViewOpen);
    const [tripCreateOpen, setTripCreateOpen] = useState(false);
    const isDeleted = route?.routeStatus !== 'active';
    const selectedRouteRevised = selectedRoute?._id === route?._id
        ? (selectedRoute?.revised || (selectedRoute?.archivedRoutes?.length || 0) > 0)
        : false;
    const isRevised = Boolean(route?.revised)
        || (route?.archivedRoutes?.length || 0) > 0
        || selectedRouteRevised;
    const chipBaseColor = isDeleted ? 'tomato' : isRevised ? '#6A5ACD' : '#1976d2';

    // Check if this route is the selected one
    const isSelected = selectedRoute?._id === route?._id;

    const handleShowDetails = () => {
        if (!selectedRoute || selectedRoute._id !== route._id) {
            //dispatch(getOneRoute({ routeName: route.routeName, routeNumber: route.routeNumber }));
        }
        dispatch(setDetailViewOpen(true));
        dispatch(setSelectedRoute(route));
    };

    const handleShowOnMap = () => {
        if (!selectedRoute || selectedRoute._id !== route._id) {
            dispatch(getOneRoute({ routeName: route.routeName, routeNumber: route.routeNumber }));
            dispatch(setSelectedRoute(route));
            dispatch(setMapViewActive(true));
        } else if (selectedRoute._id === route._id) {
            dispatch(setSelectedRoute(null));
            dispatch(setMapViewActive(false));
        }
    };

    useEffect(() => {
        if (selectedRoute?._id === route?._id) {
            console.log("RouteListItem route", selectedRoute);
        } else {
            console.log("Unselected RouteListItem route", route.routeName, route.routeStatus);
        }
    }, [route, selectedRoute]);

    const handleTripCreateClose = () => {
        console.log("Trip form closed");
        setTripCreateOpen(false);
        //handleShowDetails();
    };

    const handleTripCreateOpen = (route) => {
        dispatch(getOneRoute({ routeName: route.routeName, routeNumber: route.routeNumber }));

        setTimeout(() => {
            dispatch(setSelectedRoute(route));
            setTripCreateOpen(true);
            console.log("trp shld open")
        }, 500);
    };

    return (
        <Card
            elevation={1}
            sx={{
                backgroundColor: isSelected ? 'primary.main' : 'white',
                marginBottom: '2px',
                borderRadius: 1,
                overflow: 'hidden',
                transition: 'all 0.2s ease',
                '&:hover': {
                    filter: isSelected ? 'brightness(1.1)' : 'brightness(0.98)',
                    backgroundColor: isSelected ? 'primary.main' : '#f5f5f5',
                }
            }}
        >
            <Box sx={{ p: 2 }}>
                {/* Route Number and Name with Create Trip button */}
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    {/* Left side: Route number and name */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Typography
                            variant="body2"
                            sx={{
                                bgcolor: isSelected ? 'white' : chipBaseColor,
                                color: isSelected ? chipBaseColor : 'white',
                                border: isSelected ? `1px solid ${chipBaseColor}` : 'none',
                                px: 1,
                                py: 0.5,
                                borderRadius: 1,
                                fontSize: '0.75rem',
                                fontWeight: 500
                            }}
                        >
                            #{route.routeNumber}
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                            <Tooltip
                                title={
                                    <Box sx={{
                                        p: 1,
                                        maxWidth: 300,
                                        boxShadow: 3,
                                        borderRadius: 1,
                                        backgroundColor: 'background.paper'
                                    }}>
                                        <Typography variant="body2" sx={{ mb: 0.5 }}>
                                            <strong style={{ color: 'dodgerBlue' }}>{route.startLocation?.locationName}</strong>
                                            <em style={{ color: 'orchid' }}>{route.viaLocations?.map(loc => ` → ${loc.locationName}`).join('')}</em>
                                            → <strong style={{ color: 'midnightblue' }}>{route.endLocation?.locationName}</strong>
                                        </Typography>
                                        <Typography variant="body2" sx={{ mb: 0.5, color: 'darkorange' }}>
                                            <strong>Distance:</strong> {route.routeLength} KM
                                        </Typography>

                                    </Box>
                                }
                                arrow
                                placement="top-start"
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            bgcolor: 'background.paper',
                                            color: 'text.primary',
                                            '& .MuiTooltip-arrow': {
                                                color: 'background.paper',
                                            },
                                            p: 0,
                                            boxShadow: 3,
                                            borderRadius: 1,
                                        }
                                    }
                                }}
                            >
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontWeight: 500,
                                        color: isSelected ? 'white' : 'text.primary',
                                        cursor: 'pointer'
                                    }}
                                >
                                    {route.routeName}
                                </Typography>
                            </Tooltip>
                            {isRevised && (
                                <Chip
                                    label="Revised"
                                    size="small"
                                    sx={{
                                        height: 22,
                                        bgcolor: isSelected ? 'rgba(255,255,255,0.2)' : 'rgba(106,90,205,0.12)',
                                        color: isSelected ? 'white' : '#6A5ACD',
                                        border: `1px solid ${isSelected ? 'rgba(255,255,255,0.35)' : 'rgba(106,90,205,0.4)'}`,
                                        fontWeight: 600,
                                        '& .MuiChip-label': { px: 1 }
                                    }}
                                />
                            )}
                        </Box>
                    </Box>

                    {/* Right side: Create Trip button */}
                    {route.routeStatus === 'active' &&
                        <Tooltip title="Create New Trip on this route">
                            <IconButton
                                onClick={() => handleTripCreateOpen(route)}
                                sx={{
                                    bgcolor: isSelected ? 'rgba(255, 255, 255, 0.2)' : '#e8f5e9',
                                    '&:hover': {
                                        bgcolor: isSelected ? 'rgba(255, 255, 255, 0.3)' : '#c8e6c9'
                                    },
                                    p: 1
                                }}
                            >
                                <Icon path={mdiTruckPlusOutline} size={0.9} color={isSelected ? "white" : "#2e7d32"} />
                            </IconButton>
                        </Tooltip>
                    }
                </Box>

                {/* Action Buttons */}
                {route.routeStatus === 'active' &&
                    <Box sx={{
                        mt: 2,
                        pt: 2,
                        borderTop: '1px solid',
                        borderColor: isSelected ? 'rgba(255, 255, 255, 0.2)' : 'divider',
                        display: 'flex',
                        gap: 2
                    }}>
                        <Box
                            onClick={handleShowDetails}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                color: isSelected ? 'white' : 'primary.main',
                                cursor: 'pointer',
                                '&:hover': {
                                    color: isSelected ? 'rgba(255, 255, 255, 0.8)' : 'primary.dark',
                                    textDecoration: 'underline'
                                }
                            }}
                        >
                            <Icon path={mdiInformationOutline} size={0.7} />
                            <Typography variant="button" sx={{ fontSize: '0.75rem' }}>
                                DETAILS
                            </Typography>
                        </Box>

                        <Box
                            onClick={handleShowOnMap}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                color: isSelected ? 'white' : 'info.main',
                                cursor: 'pointer',
                                fontWeight: isSelected ? 'bold' : 'normal',
                                bgcolor: isSelected ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
                                px: 1,
                                py: 0.5,
                                borderRadius: 1,
                                '&:hover': {
                                    color: isSelected ? 'white' : 'info.dark',
                                    bgcolor: isSelected ? 'rgba(255, 255, 255, 0.3)' : 'info.50',
                                    textDecoration: 'underline'
                                }
                            }}
                        >
                            <Icon path={mdiMapOutline} size={0.7} />
                            <Typography
                                variant="button"
                                sx={{
                                    fontSize: '0.75rem',
                                    fontWeight: isSelected ? 'bold' : 'normal'
                                }}
                            >
                                {isSelected ? 'HIDE MAP' : 'SHOW MAP'}
                            </Typography>
                        </Box>


                        <Box
                            onClick={() => { dispatch(deactivateRoute({ routeId: route._id })) }}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                color: isSelected ? 'rgba(255, 200, 200, 0.9)' : 'error.main',
                                cursor: 'pointer',
                                '&:hover': {
                                    color: isSelected ? 'white' : 'error.dark',
                                    textDecoration: 'underline'
                                }
                            }}
                        >
                            <Icon path={mdiDeleteOutline} size={0.7} />
                            <Typography variant="button" sx={{ fontSize: '0.75rem' }}>
                                DELETE
                            </Typography>
                        </Box>

                    </Box>
                }
            </Box>

            {/* Modals */}

            {/* <TripCreateForm
                tripCreateOpen={tripCreateOpen}
                onTripCreateClose={handleTripCreateClose}
                initialRoute={route?.routeName}
            /> */}

            <NewTrip
                open={tripCreateOpen}
                onClose={handleTripCreateClose}
                initialRoute={route?.routeName}
            />
        </Card>
    );
};

export default RouteListItem;
